module.exports = __webpack_public_path__ + "img/82.db3a2601.png";